import React, { useContext, useState } from "react";
import { RecentlyPlayedTrack, Track } from "../spotify/spotify";
import { ReactComponent as BackArrowIcon } from "../media/back_arrow.svg";
import SongList from "./SongList";
import { ThemeContext } from "../app/App";

const SongConfirmer = ({ selectedSong, setSelectedSong, addSong }: { selectedSong: Track; setSelectedSong: (song: Track | null) => void, addSong: (song: Track) => void; }) => {
    const { theme } = useContext(ThemeContext);
    return (
        <div className="column-centered mt-5">
            <div className='absolute top-3 left-3 cursor-pointer row align-center mx-bw-5' onClick={() => setSelectedSong(null)}><BackArrowIcon /> <p>Choose Different Start Song</p></div>
            <div className="column-centered">
                { selectedSong.album.images.length > 0 && <img src={selectedSong.album.images[0].url} alt="img" className="album-art-cover-img" /> }
                <p className="text-xl font-bold mt-5">{selectedSong.name}</p>
                <p className="mb-3">by <i>{selectedSong.artists.map(a => a.name).join(', ')}</i></p>
                { 
                    selectedSong.preview_url &&
                    <audio controls>
                        <source src={selectedSong.preview_url} type="audio/mp3" />
                    </audio>
                }
            </div>
            <button className={`button border border-${theme === 'dark' ? 'white' : 'gray-700'} rounded-lg px-3 py-1 my-4`} onClick={() => addSong(selectedSong)}>Choose as my Song of the Day</button>
        </div>
    )   
}

interface SongSelectorProps {
    songList: RecentlyPlayedTrack[];
    back: () => void;
    addSong: (song: Track) => void;
}

const SongSelector: React.FC<SongSelectorProps> = ({ songList, back, addSong }) => {
    const [ selectedSong, setSelectedSong ] = useState<Track | null>(null);

    return (
        <div className="column-centered ">
            {
                selectedSong === null ?
                <SongList songList={songList} setSelectedSong={setSelectedSong} back={back} /> :
                <SongConfirmer selectedSong={selectedSong} setSelectedSong={setSelectedSong} addSong={addSong} />
            }
        </div>
    );
}

export default SongSelector;
